module.exports = __webpack_public_path__ + "static/media/ionic.fc325a91.png";